import styled from "styled-components"

export interface StyledIFrameProps {
    loaded?: boolean
}
export interface StyledMainProps {
    method?: string
}
export const StyledMain = styled.div<StyledMainProps>`
    position: relative;
    ${props => props.method === "signup" && (`
        min-height: 718px;
    `)}
    ${props => props.method === "login" && (`
        min-height: 358px;
    `)}

`
export const StyledIFrame = styled.div<StyledIFrameProps>`
    width: 100%;

    & iframe {
        width: 100%;
        ${props => props.loaded ? `
            display: block;
        ` : `
            display: none;
        `}
    }
`
